import { useRef, useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { socket } from 'api';
import { useOutsideClicker } from 'libs/hooks';
import { notify } from 'libs/common';
import { SimpleModal, BlueButton } from 'libs/ui';
import { Content, Block } from './printers-modal.styled';

export const PrintersModal = (props) => {
  const { items, close, sendControlMsg, id } = props;
  const { t } = useTranslation();
  const ref = useRef();
  const lastSidRef = useRef('');
  const timerRef = useRef(null);
  const arrowPos = undefined;
  const topPos = '40px';
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const onPrintSuccess = (data) => {
      if (loading && data.source.includes(id) && data?.data?.method.includes('printer.ticket_print_ok') && data.status === 'processed') {
        notify(t('windows.Внимание'), t('Действие успешно выполнено'), 'success');
        setLoading(false);
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
        timerRef.current = null;
        close();
      }
    };

    socket.on('add_event', onPrintSuccess);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      socket.off('add_event', onPrintSuccess);
    };
  }, [loading, id]);

  useOutsideClicker(ref, () => {
    close();
  });

  const printItem = (sid) => {
    lastSidRef.current = sid;
    // lastSid = sid;
    sendControlMsg('print_receipt', null, { sid });
    setLoading(true);
    timerRef.current = setTimeout(() => {
      setLoading(false);
      notify(t('windows.Внимание'), t('Ошибка печати'));
      timerRef.current = null;
    }, 10000);
  };

  const itemsEl = useMemo(() => {
    const cl = loading ? 'loading' : '';
    return items.map((el, idx) => {
      return (
        <Block key={idx}>
          {/* <ItemTitle>{el.name}</ItemTitle> */}
          <BlueButton className={cl} onClick={() => printItem(el.sid)} disabled={loading}>
            {el.name}
          </BlueButton>
        </Block>
      );
    });
  }, [loading]);

  // const itemsEl = getItemsEl();

  return (
    <SimpleModal className="confirm" $above={false} $arrowPos={arrowPos} $topPos={topPos} $minWidth={'190px'} ref={ref}>
      <Content>{itemsEl}</Content>
    </SimpleModal>
  );
};
